<template>
  <div>
    <h1>Regional Sales</h1>
    <hr>

    <!-- FILTER STARTS -->
    <flexibleFilter
      :dealer_filter="false"
      :fetch_filter="fetchFilter"
      @onFilter="setFilterUrl"
    ></flexibleFilter>
    <!-- FILTER ENDS -->

    <!-- STATS START -->
    <stats
      :filterUrl="filterUrl"
    ></stats>
    <!-- STATS END-->

    <!-- Top 10 Sales By Karesidenan Start -->
    <top-sales-by-karesidenan
      :filterUrl="filterUrl"
    ></top-sales-by-karesidenan>
    <!-- Top 10 Sales By Dealer End -->

    <!-- Top 10 Sales By Sub Series Start -->
      <top-sales-by-sub-series
      :filterUrl="filterUrl"
    ></top-sales-by-sub-series>
    <!-- Top 10 Sales By Sub Series End -->
  </div>
</template>

<script>
  import flexibleFilter from '@/components/filter/flexible_filter.vue'

  import stats from './children/stats'
  import topSalesByKaresidenan from './children/topSalesByKaresidenan'
  import topSalesBySubSeries from './children/topSalesBySubSeries'

  export default {
    data () {
      return {
        filterUrl : '',
        fetchFilter : 0,
      }
    },
    components : {
      flexibleFilter,
      stats,
      topSalesByKaresidenan,
      topSalesBySubSeries,
    },
    mounted () {
      this.fetchFilter++;
    },
    methods : {
      setFilterUrl(a){
        this.filterUrl = a
      }
    }
  }
</script>

<style scoped>
  
</style>